import { render } from "./notifications.vue?vue&type=template&id=69626a77"
import script from "./notifications.js?vue&type=script&lang=js&external"
export * from "./notifications.js?vue&type=script&lang=js&external"

import "./notifications.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__